import { configureStore } from "@reduxjs/toolkit";
import kanbanReducer from "./slices/kanbanSlice";
import statusReducer from "./slices/statusSlice";
import commonReducer from "./slices/commonSlice";
import taskSlice from "./slices/TaskSlice";
import attendanceSlice from "./slices/attendanceSlice";
import userSlice from "./slices/userSlice";
import leadsSlice from "./slices/leadSlice";
import authReducer from "./slices/authSlice";
import productSlice from "./slices/productSlice";
import epcSlice from "./slices/epcSlice";
import customerSlice from "./slices/customerSlice";
import orderSlice from "./slices/orderSlice";
import excelSlice from "./slices/Factory/excelSlice";
import newFrelitOrderSlice from "./slices/frelitOrderSlice";
import productSnSlice from "./slices/productsSnSlice";
import whatsAppDataSlice from "./slices/whatsappDataSlice";
import telecallerBoard from "./slices/telecallerLeadSlice";
import telecallerSession from "./slices/telecallerSessionSlice";
import billOfMaterials from "./slices/bomSlice";
import roundRobinSlice from "./slices/roundRobinSlice";
import kanbanFiltersSlice from "./slices/kanbanFiltersSlice";
import quotationSlice from "./slices/quotationSlice";
import leaveReducer from "./slices/leaveSlice";
import taskManagementSlice from "./slices/taskmanagementSlice";
import employeeReducer from "./slices/employeeSlice";
import regularizeReducer from "./slices/regularizeSlice";
import payrollReducer from "./slices/payrollSlice";
import musterReducer from "./slices/musterSlice";
import warehouseReducer from "./slices/warehouseSlice";
import storeInwardReducer from "./slices/storeInwardSlice";
import floorInwardReducer from "./slices/floorInwardSlice";
import managerWarehouseReducer from "./slices/managerWarehouseSlice";
import warrantyDetailsReducer from "./slices/warrantyDetailsSlice";
import gpHierarchyReducer from "./slices/gpHierarchySlice";
import productionCostReducer from "./slices/productionCostSlice";
import adminDashboardReducer from "./slices/adminDashboardSlice";
import hrDashboardReducer from "./slices/hrDashboardSlice";
import stockTransferReducer from "./slices/StockTransfer/stockTransferSlice";
import materialStockTransferReducer from "./slices/StockTransfer/materialStockTransferSlice";
import ServiceManagementReducer from "./slices/serviceManagementSlice";
import DefectiveMaterialReducer from "./slices/defectiveMaterialSlice";
import materialReturnReducer from "./slices/Factory/materialReturnSlice";
import commissionAndRepayment from "./slices/commissionAndRepaymentSlice";
import routesSlice from "./slices/navigationSlice";
import shrinkSlice from "./slices/shrinkSlice";
import priceListSlice from "./slices/priceListSlice";
import productBOMSlice from "./slices/productBOMSlice";
import newFloorSlice from "./slices/Factory/newFloorSlice";
import newStoreSlice from "./slices/Factory/newStoreSlice";
import copyBomReducer from "./slices/Factory/copyBomSlice";
import factoryReducer from "./slices/Factory/factorySlice";
import whatsappCampaignReducer from "./slices/whatsappCampaignSlice";
import einvoiceSlice from "./slices/einvoiceSlice";
import dispatchReplacementReducer from "./slices/dispatchReplacementSlice";
import refurbishedStockReducer from "./slices/refurbishedStockSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    kanban: kanbanReducer,
    status: statusReducer,
    common: commonReducer,
    task: taskSlice,
    attendance: attendanceSlice,
    users: userSlice,
    leadSlice: leadsSlice,
    product: productSlice,
    epc: epcSlice,
    customer: customerSlice,
    order: orderSlice,
    excel: excelSlice,
    frelitOrder: newFrelitOrderSlice,
    productSn: productSnSlice,
    whatsAppData: whatsAppDataSlice,
    telecallerLead: telecallerBoard,
    telecallerSession: telecallerSession,
    billOfMaterials: billOfMaterials,
    roundRobin: roundRobinSlice,
    kanbanFilters: kanbanFiltersSlice,
    quotations: quotationSlice,
    leave: leaveReducer,
    TaskManagement: taskManagementSlice,
    employee: employeeReducer,
    regularize: regularizeReducer,
    payroll: payrollReducer,
    muster: musterReducer,
    warehouse: warehouseReducer,
    storeInward: storeInwardReducer,
    floorInward: floorInwardReducer,
    managerWarehouse: managerWarehouseReducer,
    warrantyDetails: warrantyDetailsReducer,
    gpHierarchy: gpHierarchyReducer,
    productionCost: productionCostReducer,
    adminDashboard: adminDashboardReducer,
    hrDashboard: hrDashboardReducer,
    stockTransfer: stockTransferReducer,
    materialStockTransfer: materialStockTransferReducer,
    serviceManagement: ServiceManagementReducer,
    defectiveMaterial: DefectiveMaterialReducer,
    commissionAndRepayment: commissionAndRepayment,
    routesSlice: routesSlice,
    shrink: shrinkSlice,
    priceList: priceListSlice,
    productBOM: productBOMSlice,
    newFloor: newFloorSlice,
    newStore: newStoreSlice,
    copyBom: copyBomReducer,
    factory: factoryReducer,
    whatsappCampaign: whatsappCampaignReducer,
    einvoice: einvoiceSlice,
    materialReturn: materialReturnReducer,
    dispatchReplacement: dispatchReplacementReducer,
    refurbishedStock: refurbishedStockReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
